import { useState } from "react";
import { useWSInCardStatus } from "../hooks/useWebSocket";

const CardConditionalHighlight = ({ children, card }) => {
  const [highlight, setHighlight] = useState(false);

  let inactiveBorderColor;
  switch (card.type) {
    case "action":
      inactiveBorderColor = "border-ghost-white";
      break;
    case "trigger":
      inactiveBorderColor = "border-seasalt";
      break;
    default:
      inactiveBorderColor = "";
  }

  useWSInCardStatus((message) => {
    if (message.type === "card_status" && message.card_id === String(card.id)) {
      if (message.status === "running") {
        setHighlight(true);
      } else if (message.status === "default") {
        setTimeout(() => {
          setHighlight(false);
        }, 1000);
      } else if (message.status === "pulse") {
        setHighlight(true);
        setTimeout(() => {
          setHighlight(false);
        }, 1000);
      }
    }
  });

  return (
    <div
      className={`relative overflow-hidden w-full h-full border-1 ${
        highlight ? "border-light-green-500 animate-pulse" : inactiveBorderColor
      } `}
    >
      {children}
    </div>
  );
};

const CardTitle = ({ title }) => {
  return (
    <h2 className="text-md font-semibold text-gray-700 text-center">{title}</h2>
  );
};

const CardLastMessageTimedelta = ({ lastMessage }) => {
  if (!lastMessage) {
    return <p className="text-xs text-gray-500 mx-auto">No logs yet</p>;
  }

  const messageTime = new Date(lastMessage.timestamp);
  const currentTime = new Date();
  const timeDifference = currentTime - messageTime;
  const totalMinutes = Math.floor(timeDifference / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  let timeText = "";
  if (totalMinutes < 1) {
    timeText = "less than 1 minute ago";
  } else if (hours > 0) {
    timeText = `${hours} ${hours === 1 ? "hour" : "hours"}${
      minutes > 0 ? ` ${minutes} ${minutes === 1 ? "minute" : "minutes"}` : ""
    } ago`;
  } else {
    timeText = `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
  }

  return <p className="text-xs text-gray-500 mx-auto">{timeText}</p>;
};

export { CardConditionalHighlight, CardTitle, CardLastMessageTimedelta };
